import { NotificationData } from ".";

const notificationDatas: NotificationData[] = [
  {
    code: "KFW-000", // DO NOT USE!
    developerMessage: "Unknown warning.",
    type: "warning",
  },
  {
    code: "KFW-001",
    developerMessage: "Some text content has been lost with this operation.",
    type: "warning",
    undoable: true,
  },
];

export default notificationDatas;
